import apiClient from './client'

import type {
  ContactoInput,
  ContactoListItem,
  PaginatedResponse,
  Persona,
  PersonaRelacion,
  PersonaRelacionInput,
  TipoContacto
} from '@/types/gia'

interface ContactoFilters {
  page?: number
  page_size?: number
  tipo?: string
  activo?: boolean
  q?: string
}

const contactosApi = {
  // ---- Contactos CRUD ----
  list: async (filters: ContactoFilters = {}): Promise<PaginatedResponse<ContactoListItem>> => {
    const response = await apiClient.get<PaginatedResponse<ContactoListItem>>('/contactos/', {
      params: filters
    })

    return response.data
  },

  get: async (id: number): Promise<Persona> => {
    const response = await apiClient.get<Persona>(`/contactos/${id}/`)

    return response.data
  },

  create: async (data: ContactoInput): Promise<Persona> => {
    const response = await apiClient.post<Persona>('/contactos/', data)

    return response.data
  },

  update: async (id: number, data: Partial<ContactoInput>): Promise<Persona> => {
    const response = await apiClient.patch<Persona>(`/contactos/${id}/`, data)

    return response.data
  },

  delete: async (id: number) => {
    await apiClient.delete(`/contactos/${id}/`)
  },

  // ---- Tipos de Contacto ----
  listTypes: async (): Promise<TipoContacto[]> => {
    const response = await apiClient.get<TipoContacto[]>('/tipos-contacto/')

    return response.data
  },

  createType: async (data: Partial<TipoContacto>): Promise<TipoContacto> => {
    const response = await apiClient.post<TipoContacto>('/tipos-contacto/', data)

    return response.data
  },

  updateType: async (id: number, data: Partial<TipoContacto>): Promise<TipoContacto> => {
    const response = await apiClient.put<TipoContacto>(`/tipos-contacto/${id}/`, data)

    return response.data
  },

  deleteType: async (id: number) => {
    await apiClient.delete(`/tipos-contacto/${id}/`)
  },

  // ---- Relaciones ----
  listRelaciones: async (params: { persona?: number; contacto?: number } = {}): Promise<PersonaRelacion[]> => {
    const response = await apiClient.get<PersonaRelacion[]>('/relaciones/', { params })

    return response.data
  },

  createRelacion: async (data: PersonaRelacionInput): Promise<PersonaRelacion> => {
    const response = await apiClient.post<PersonaRelacion>('/relaciones/', data)

    return response.data
  },

  updateRelacion: async (id: number, data: Partial<PersonaRelacionInput>): Promise<PersonaRelacion> => {
    const response = await apiClient.patch<PersonaRelacion>(`/relaciones/${id}/`, data)

    return response.data
  },

  deleteRelacion: async (id: number) => {
    await apiClient.delete(`/relaciones/${id}/`)
  }
}

export default contactosApi
